import { Controller } from "@hotwired/stimulus"

// Highlights search term matches in table cells within scope.
// Reads the search term from the input target.
export default class extends Controller {
  static targets = ["input"]

  connect() {
    if (!this.hasInputTarget || !this.inputTarget.value) return

    const term = this.inputTarget.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const regex = new RegExp('(' + term + ')', 'gi')

    this.element.querySelectorAll('td').forEach(function(td) {
      td.innerHTML = td.innerHTML.replace(regex, '<mark>$1</mark>')
    })
  }
}
